export * from '@fhs/routing/src/routes/v2/menu/(menu)/[slug]/customize';
export { default } from '@fhs/routing/src/routes/v2/menu/(menu)/[slug]/customize';
